import React, { Component } from "react";
import { connect } from "react-redux";

class Header extends Component {
  constructor() {
    super();
    this.state = { isToggleOn: false };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.setState(prevState => ({
      isToggleOn: !prevState.isToggleOn
    }));
  }

  renderSmallMenu() {
    if (this.state.isToggleOn === true) {
      return (
        <ul className="sidenav hide-on-large-only" id="mobile">
          <li>
            <a href="/search" style={{ color: "#999999" }}>
              Find out your twin
            </a>
          </li>
          <li>
            <a href="/ranking" style={{ color: "#999999" }}>
              Ranking
            </a>
          </li>
          {this.renderContent()}
        </ul>
      );
    }
  }

  renderContent() {
    //console.log(this.props.auth);
    switch (this.props.auth) {
      case null:
        return;
      case false:
        return (
          <li>
            <a href="/auth/google" style={{ color: "#999999" }}>
              Log in With Google
            </a>
          </li>
        );
      default:
        return (
          <li>
            <a href="/api/logout" style={{ color: "#999999" }}>
              Logout
            </a>
          </li>
        );
    }
  }

  render() {
    return (
      <div>
        <nav className="white navbar-fixed z-depth-0">
          <div
            className="nav-wrapper white black-text"
            style={{
              borderBottom: "2px solid #999999",
              borderBottomColor: "#999999"
            }}
          >
            <a
              className="left brand-logo lookaliker"
              href="/"
              style={{ color: "#999999" }}
            >
              <font color="#999999">
                <img
                  src={require("../assets/logo.png")}
                  width="25px"
                  alt="logo"
                />&nbsp; LOOKALIKER
              </font>
            </a>
            <a
              href="#"
              onClick={this.handleClick}
              className="sidenav-trigger hide-on-large-only right"
              style={{ color: "#999999" }}
            >
              <i className="material-icons">menu</i>
            </a>
            <ul className="right hide-on-med-and-down	">
              <li>
                <a href="/search" style={{ color: "#999999" }}>
                  Find out your twin
                </a>
              </li>
              <li>
                <a href="/ranking" style={{ color: "#999999" }}>
                  Ranking
                </a>
              </li>
              {this.renderContent()}
            </ul>
          </div>
        </nav>
        {this.renderSmallMenu()}
      </div>
    );
  }
}

function mapStateToProps({ auth }) {
  return { auth };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/Header.js